export default "__VITE_ASSET__leyFyrS2__"